import { Typography } from '@material-ui/core'
import * as React from 'react'

import './styles.scss'

export interface IProps {
  title?: string
  children?: React.ReactNode
}

export const Note: React.FC<IProps> = ({ title, children }) => (
  <div className="note">
    <Typography className="note-title">
      {title ? title : 'Please note'}
    </Typography>
    <div className="note-content">{children}</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Note/index.tsx